import { render, staticRenderFns } from "./PromoBar.vue?vue&type=template&id=19e80e82&lang=html&"
import script from "./PromoBar.vue?vue&type=script&lang=js&"
export * from "./PromoBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports